import { useSyncExternalStore } from "react";

const noopSubscribe = () => () => {};

/**
 * False on the server and during hydration, true afterwards. Use it to keep
 * browser-only UI (localStorage, viewport, session state) out of the
 * server-rendered HTML without causing hydration mismatches.
 */
export const useHydrated = (): boolean =>
  useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false,
  );
